module.exports = __webpack_public_path__ + "img/linksms-big.65c0e9a1.png";